import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * { box-sizing: border-box; }

  /* color-scheme según el tema activo: evita que el SO pinte texto negro (canvastext)
     en controles/botones cuando el dispositivo está en modo claro y la app en oscuro. */
  :root { color-scheme: ${({ theme }) => theme.name}; }

  html, body, #root { height: 100%; }

  html {
    font-size: 17px;
    background: ${({ theme }) => theme.colors.bg};
    color: ${({ theme }) => theme.colors.text};
  }

  body {
    margin: 0;
    font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
    font-size: 1rem;
    line-height: 1.45;
    background: ${({ theme }) => theme.colors.bg};
    color: ${({ theme }) => theme.colors.text};
    -webkit-font-smoothing: antialiased;
  }

  a { color: inherit; text-decoration: none; }

  /* Botones heredan el color del tema (no el canvastext del SO) → arregla texto negro. */
  button {
    font: inherit;
    color: inherit;
    cursor: pointer;
    min-height: 44px;
    -webkit-tap-highlight-color: transparent;
  }

  /* Inputs/selects también siguen el tema. */
  input, select, textarea { color: inherit; }

  @media (prefers-reduced-motion: reduce) {
    * { animation: none !important; transition: none !important; }
  }
`;
